import { Component, Input } from '@angular/core';

/**
 * Generated class for the MetricCardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'metric-card',
  templateUrl: 'metric-card.html'
})
export class MetricCardComponent {
  @Input() title: string;

  @Input() value: any;
}



// WEBPACK FOOTER //
// ./src/components/metric-card/metric-card.ts